//import * as poseDetection from '@tensorflow-models/pose-detection';
// import * as tf from '@tensorflow/tfjs';
import * as posenet from '@tensorflow-models/posenet';
import '@tensorflow/tfjs';

// eslint-disable-next-line no-restricted-globals
// self.onmessage = (event) => {
//     console.log("poseDetectionWorker onmessage is triggered", event);
// };

// eslint-disable-next-line no-restricted-globals
self.addEventListener('message', async (event) => {
    console.log("poseDetectionWorker is triggered");
    const { imageData, width, height } = event.data;
    console.log("poseDetectionWorker is triggered", imageData, width, height);

    if (imageData) {
        console.log("frameProcessed is triggered");
        // Create a new ImageData object
        const imgData = new ImageData(new Uint8ClampedArray(imageData), width, height);

        let isCorrect = await detectPose(imgData);
        // eslint-disable-next-line no-restricted-globals
        self.postMessage({ poseDetected: true, isCorrect: isCorrect });
    } else {
        console.error("No imageData received");
        // eslint-disable-next-line no-restricted-globals
        self.postMessage({ poseDetected: true, isCorrect: false });
    }
});

// eslint-disable-next-line no-restricted-globals
self.addEventListener('error', (event) => {
    console.error("Worker error:", event);
});

// const createPoseDetector = async () => {
//     // Ensure TensorFlow.js is ready
//     // await tf.ready();

//     // Create a detector
//     const model = poseDetection.SupportedModels.BlazePose;
//     const detectorConfig = {
//         runtime: 'tfjs',
//         modelType: 'full'
//     };
//     const detector = await poseDetection.createDetector(model, detectorConfig);
//     return detector;
// }

async function detectPose(imageData) {
    console.log("poseDetection is triggered");
    
    // const detector = await createPoseDetector();

    // const poses = await detector.estimatePoses(imageData);
    
    // if (poses.length > 0) {
    //   const isCorrect = isCorrectPose(poses[0]);
    //   console.log(isCorrect ? "Correct pose" : "Incorrect pose");
    //   return isCorrect;
    // }

    const net = await posenet.load();
    // const canvas = document.createElement('canvas');
    // canvas.width = imageData.width;
    // canvas.height = imageData.height;

    // const context = canvas.getContext('2d');
    // context.putImageData(imageData, 0, 0);

    const pose = await net.estimateSinglePose(imageData, {
        flipHorizontal: false,
    });
    console.log("pose:", pose);
    const isAlphaPose = checkAlphaPose(pose);
    console.log("isAlphaPose:", isAlphaPose);
    return isAlphaPose;

    return false;
  }

  function isCorrectPose(pose) {
    console.log("pose:", pose);

    if (!pose || !pose.keypoints) return false;
  
    const keypoints = pose.keypoints;
    const nose = keypoints[0];
    const leftEye = keypoints[2];
    const rightEye = keypoints[5];
    const leftShoulder = keypoints[11];
    const rightShoulder = keypoints[12];
    const leftHip = keypoints[23];
    const rightHip = keypoints[24];
    const leftWrist = keypoints[15];
    const rightWrist = keypoints[16];
  
    // Check if standing straight
    const shoulderSlope = Math.abs(leftShoulder.y - rightShoulder.y);
    const hipSlope = Math.abs(leftHip.y - rightHip.y);
    const isUpright = shoulderSlope < 0.05 && hipSlope < 0.05;
  
    // Check if hands are visible
    const areHandsVisible = leftWrist.score > 0.5 && rightWrist.score > 0.5;
  
    // Check if looking into the camera
    const isLookingAtCamera = () => {
        if (nose.score < 0.7 || leftEye.score < 0.3 || rightEye.score < 0.3) {
          return false;
        }
        
        // Calculate the midpoint between the eyes
        const eyeMidpointX = (leftEye.x + rightEye.x) / 2;
        const eyeMidpointY = (leftEye.y + rightEye.y) / 2;
        
        // Calculate the distance between the nose and eye midpoint
        const distanceX = Math.abs(nose.x - eyeMidpointX);
        const distanceY = Math.abs(nose.y - eyeMidpointY);
        
        console.log("distanceX:", distanceX);
        console.log("distanceY:", distanceY);

        // Relaxed check if the nose is close to the midpoint of the eyes
        const thresholdX = 2; // Increased from 0.03
        const thresholdY = 15; // Increased and separate threshold for Y
        return distanceX < thresholdX && distanceY < thresholdY;
      };
  
    // Check if head is properly visible
    const isHeadVisible = nose.score > 0.9;
    
    const isLookingAtCamera1 = isLookingAtCamera(pose);

    console.log("isLookingAtCamera:", isLookingAtCamera1);
    console.log("isHeadVisible:", isHeadVisible);
    console.log("isUpright:", isUpright);
    console.log("areHandsVisible:", areHandsVisible);
  
    return isUpright && areHandsVisible && isLookingAtCamera1 && isHeadVisible;
  }

  const checkAlphaPose = (pose) => {
    console.log("checkAlphaPose is triggered");
    const { keypoints } = pose;

    const leftShoulder = keypoints.find(k => k.part === 'leftShoulder');
    const rightShoulder = keypoints.find(k => k.part === 'rightShoulder');
    const leftWrist = keypoints.find(k => k.part === 'leftWrist');
    const rightWrist = keypoints.find(k => k.part === 'rightWrist');

    console.log("leftShoulder:", leftShoulder);
    console.log("rightShoulder:", rightShoulder);
    console.log("leftWrist:", leftWrist);
    console.log("rightWrist:", rightWrist);

    return leftShoulder.score > 0.5 && rightShoulder.score > 0.5 &&
           leftWrist.score > 0.5 && rightWrist.score > 0.5 &&
           leftShoulder.position.y < leftWrist.position.y &&
           rightShoulder.position.y < rightWrist.position.y;
};

const detectAlphaPose = async (net, imageData) => {
    console.log("detectAlphaPose is triggered");
    const pose = await net.estimateSinglePose(imageData, {
        flipHorizontal: false,
    });
    console.log("pose:", pose);
    return pose;
};